import { getValueOrDefault } from "./getValueOrDefault";

export const getRemValue = (value = 1) => value * parseFloat(getValueOrDefault("ui_scale", "10.5px").split("px")[0]);
